<template lang="pug">
.position-relative
	// Hero 
	//-section.heroPlastomex
		div(style='height: fit-content')
			h1.h-titulo
			p.lead.h-subtitulo  Los mejores productos y servicios para aligerar tu carga

	section.heroPlastomex
		div.d-lg-none#textoHero(style='height: fit-content')
			p.lead.h-subtitulo(st)  Los mejores productos y servicios para aligerar tu carga
		b-carousel.d-lg-block#carousel-fade(style='text-shadow: 0px 0px 2px #000; display: none' fade background='#444')
			b-carousel-slide(caption='Los mejores productos y servicios para aligerar tu carga', img-src='/img/optimizadas/INICIO_4.png')
			b-carousel-slide(caption='', img-src='/img/optimizadas/INICIO_2.jpg')
			b-carousel-slide(caption='', img-src='/img/optimizadas/INICIO_3.jpg')

	.container-fluid
		.container
			section
				h2.sublinea-centro
					span Somos la mejor opción
					|  Nuestras Ventajas
				.row.ventajas.justify-content-center
					//-.col-md-4.text-md-left(data-sal="fade-in", data-sal-delay="200", data-sal-duration="900")
						| Productos con los más altos estándares de calidad.
					//-.col-md-4.text-md-center(data-sal="fade-in", data-sal-delay="400", data-sal-duration="900")
						| Hacemos alianzas con nuestros clientes pensando en el largo plazo.
					//-.col-md-4.text-md-right(data-sal="fade-in", data-sal-delay="600", data-sal-duration="900")
						| Nos esforzamos para ofrecer el mejor servicio del mercado.
					.col-md-8
						ul
							li Productos con los más altos estándares de calidad.
							li Hacemos alianzas con nuestros clientes pensando en el largo plazo.
							li Nos esforzamos para ofrecer el mejor servicio del mercado.
				.row
					.col-6.d-md-flex.align-self-center.d-none
						picture
							source(srcset='/img/optimizadas/IMG_7021.webp' type="image/webp" )
							img(src='/img/optimizadas/IMG_7021.jpg', width='100%')
						
					.col-md-6
						.linea
							h2 ¿Por qué elegirnos?
						.motivo
							img(src='../assets/img/icons/svg/20AÑOS.svg', data-sal="slide-right", data-sal-duration="900")
							div(data-sal="slide-left", data-sal-duration="900")
								h3.text-left 20 años de experiencia
								p
									| Gracias al compromiso y alianza con nuestros clientes estamos en constante crecimiento.
						.motivo
							img(src='../assets/img/icons/svg/CALIDAD.svg' data-sal="slide-right", data-sal-duration="900")
							div(data-sal="slide-left", data-sal-duration="900")
								h3 Calidad
								p
									| Fabricamos productos resistentes siempre, los cuales excedan las exigencias que se tienen.
						.motivo
							img(src='../assets/img/icons/svg/SERVICIO.svg' data-sal="slide-right", data-sal-duration="900")
							div(data-sal="slide-left", data-sal-duration="900")
								h3 Servicio
								p
									| Contamos con un área de atención al cliente para mejorar el servicio y estar con ustedes en todo momento.
						.motivo
							img(src='../assets/img/icons/svg/EFICIENCIA.svg' data-sal="slide-right", data-sal-duration="900")
							div(data-sal="slide-left", data-sal-duration="900")
								h3 Eficiencia
								p
									| Procesos y productos eficientes para estar cuando nos necesita y con el producto adecuado.

		.row.medidores
			.col-md(data-sal="slide-up", data-sal-delay="300", data-sal-duration="900")
				strong {{ formateado(kgreciclados) }}
				span kg reciclados
			.col-md(data-sal="slide-up", data-sal-delay="500", data-sal-duration="900")
				strong {{ formateado(arbolesSalvados) }}
				span árboles salvados
			.col-md(data-sal="slide-up", data-sal-delay="700", data-sal-duration="900")
				strong {{ aniosExperiencia }}
				span  años de experiencia
			//-.col-6.col-md(data-sal="slide-up", data-sal-delay="700", data-sal-duration="900")
				strong 29 k
				span  cajas diarias
		
			
		section.container.my-5
			h2.sublinea-centro
				span Clientes satisfechos
				|  Testimonios
			//-carousel-3d( :controls-visible="true", :width="600", :height="500")
				slide(:index='0')
					img(src="../assets/img/testimonios/DG.png", width="80%")
				slide(:index='1')
					img(src="../assets/img/testimonios/PRODELEC.png")
					p.testimonial
						| Con Plastomex mantenemos una excelente relación como cliente-proveedor en el suministro de material eléctrico, por ser una empresa confiable por más de 10 años.
					p.overview
						b Francisco Salvador Marquez
						| , Gerente Ventas Sucursal Tecnológico
				slide(:index='2')
					img(src="../assets/img/testimonios/PLASTOMEX.png")
					p.testimonial
						| 12 años formando parte de plastomex, me gusta mi trabajo, lo que hago y el ambiente. cuando descanso vengo a la planta con mas ganas de seguir trabajando.
					p.overview
						b J. Artemio Garcia Garcia
						| , Auxiliar De Inyeccion

				hr
			carousel-3d( :perspective="180" :display="1" :controls-visible="true", :autoplay="true",:autoplayTimeout="3000", :width="400", :height="250", @before-slide-change="currentIndex = $event")
				slide(v-for='(testimonio, i) in testimonios', :index='i', :key='i')
					img(:src='testimonio.img')
					
			p.testimonial
				| {{testimonios[currentIndex].testimonio}}
			p.overview
				b {{testimonios[currentIndex].autor}}
				| , {{testimonios[currentIndex].puesto}}


		
			

			
		section.mt-5
			.container
				h2.sublinea-centro
					span 
					|  ¿Quiénes Somos?
				p.text-center 20 años desarrollando productos plásticos para el campo. Desde 1999 somos proveedores de productos plásticos para el mercado agrícola con altos estándares de calidad tanto en nuestros productos como en el servicio. 
				
				//-vue-vimeo-player(ref='player', @ready="onReady"  player-width='100%'  :video-id='344135000', :options="{color:'74aa50',title:0,byline:0,portrait:0,responsive:1}"  )
				
				div.d-flex
					<iframe class="mx-3 mx-auto " width="100%" height="450px" src="https://www.youtube-nocookie.com/embed/dfnh328sgOY?rel=0&amp;showinfo=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import { vueVimeoPlayer } from "vue-vimeo-player";
import testimonios from "@/data/testimonios";

import sal from "sal.js";

export default {
	components: {
		Carousel3d,
		Slide,
		vueVimeoPlayer
	},
	data() {
		return {
			currentIndex: 0,
			testimonios,
			windowWidth: 0
		};
	},
	methods: {
		onReady() {
			//console.log(document.getElementsByClassName('vp-controls-wrapper'));
			//var iframe = document.getElementsByTagName(iframe);
			//console.log(iframe);
			//var innerDoc = iframe.contentDocument || iframe.contentWindow.document;
			//console.log(innerDoc);
		},
		show(e) {
			console.log(e);
		},
		getWindowWidth(event) {
			this.windowWidth = document.documentElement.clientWidth;
		},
		formateado(i) {
			return new Intl.NumberFormat("es-MX").format(i);
		}
	},
	computed: {
		videoWidth() {
			return window.innerWidth;
		},
		diff() {
			return (new Date() - new Date("2019-07-01")) / 1000;
		},
		kgreciclados() {
			return Math.floor(30000000 + this.diff * 0.21);
		},
		arbolesSalvados() {
			return Math.floor(2500000 + this.diff * 0.0001);
		},
		aniosExperiencia() {
			return 20 + (new Date().getYear() - new Date("2019-07-01").getYear());
		}
	},
	mounted() {
		sal({
			threshold: 0.7,
			once: true
		}),
			this.$nextTick(function() {
				window.addEventListener("resize", this.getWindowWidth);
				//window.addEventListener('resize', this.getWindowHeight);

				//Init
				this.getWindowWidth();
				//this.getWindowHeight()
			});
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.getWindowWidth);
		//window.removeEventListener('resize', this.getWindowHeight);
	}
};
</script>

<style lang="scss" scoped >
#textoHero {
	margin-top: auto;
}
.heroPlastomex {
	background-image: url("/img/optimizadas/INICIO_movil.png");
}
.webp .heroPlastomex{
		background-image: url('/img/optimizadas/DSC03114.webp');
	}
img.w-100 {
	object-position: 70%;
}

.heroPlastomex {
	z-index: 11;
	bottom: 5%;
}
.testimonial {
	text-align: justify;
	max-width: 700px;
	margin: 0 auto 1em;
}
.overview {
	font-style: italic;
	text-align: center;
	b {
		color: #74aa50;
		text-transform: uppercase;
	}
}
.motivo {
	text-align: justify;
}
.carousel-3d-slide {
	border: none !important;
	background: #faf9f9 !important;
}

/* .carousel-3d-slide .left-1 {
	background: rgb(235,235,235);
	background: linear-gradient(123deg, rgba(235,235,235,0.11528361344537819) 0%, rgba(0,0,0,0.7315301120448179) 100%);
} */
</style>